import styles from './Areas.module.scss'

const AREAS = [
  {
    icon: 'record_voice_over',
    title: 'Fala e sons da fala',
    text: 'Tratamento de dificuldades na produção dos sons da fala, como trocas, omissões e distorções.',
  },
  {
    icon: 'chat',
    title: 'Linguagem',
    text: 'Avaliação e intervenção nas dificuldades de compreensão e expressão da linguagem.',
  },
  {
    icon: 'graphic_eq',
    title: 'Fluência',
    text: 'Acompanhamento para pessoas que apresentam gagueira e outras disfluências.',
  },
  {
    icon: 'face',
    title: 'Motricidade orofacial',
    text: 'Trabalho das funções relacionadas à fala, mastigação, deglutição e respiração.',
  },
  {
    icon: 'mic',
    title: 'Voz e oratória',
    text: 'Aprimoramento da comunicação profissional, da voz, da dicção e da clareza ao falar.',
  },
  {
    icon: 'groups',
    title: 'Consultoria para famílias',
    text: 'Orientação aos responsáveis sobre estímulos e estratégias de comunicação.',
  },
]

const Areas = () => (
  <section id="servicos" className={styles.section}>
    <div className={styles.inner}>
      <p className={styles.kicker}>Áreas de atuação</p>
      <h2>Atendimento completo para crianças, adolescentes e adultos</h2>

      <div className={styles.grid}>
        {AREAS.map(area => (
          <article key={area.title} className={styles.card}>
            <span className={styles.icon}>
              <i className="material-icons">{area.icon}</i>
            </span>
            <h3>{area.title}</h3>
            <p>{area.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default Areas
